import type {AgentSettings} from 'src/types/scheduler/settings';
import type {SchedulerSettingsActions} from 'src/action-creators/scheduler/settings';

import {
  SET_AGENT_SETTINGS,
  SET_TIMEZONE,
  SET_UPDATED_TIME_OFFS,
  SET_DAILY_DIGEST,
  SET_BOOKING_HOURS,
  SET_USER_PRINCIPAL_NAME,
  SET_MAX_EVENTS_PER_DAY,
  SET_AGENT_LANGUAGE,
} from 'src/action-creators/scheduler/settings';


export type SchedulerSettingsState = {
  agentSettings: AgentSettings;
};

export const initialState: SchedulerSettingsState = {
  agentSettings: {
    businessHours: [],
    timeOff: [],
    timezone: '',
    schedulerEnableDailyDigest: false,
    schedulerMaxEventsPerDay: -1,
    userPrincipalName: '',
    agentLanguage: 'en',
  },
};

export default function schedulerSettings(
  state: SchedulerSettingsState = initialState,
  action: SchedulerSettingsActions,
): SchedulerSettingsState {
  switch (action.type) {
    case SET_AGENT_SETTINGS: {
      return {
        ...state,
        agentSettings: action.payload,
      };
    }
    case SET_USER_PRINCIPAL_NAME: {
      return {
        ...state,
        agentSettings: {
          ...state.agentSettings,
          userPrincipalName: action.payload,
        },
      };
    }
    case SET_DAILY_DIGEST: {
      return {
        ...state,
        agentSettings: {
          ...state.agentSettings,
          schedulerEnableDailyDigest: action.payload,
        },
      };
    }
    case SET_MAX_EVENTS_PER_DAY: {
      return {
        ...state,
        agentSettings: {
          ...state.agentSettings,
          schedulerMaxEventsPerDay: action.payload,
        },
      };
    }
    case SET_TIMEZONE: {
      return {
        ...state,
        agentSettings: {
          ...state.agentSettings,
          timezone: action.payload,
        },
      };
    }
    case SET_BOOKING_HOURS: {
      return {
        ...state,
        agentSettings: {
          ...state.agentSettings,
          businessHours: action.payload,
        },
      };
    }
    case SET_UPDATED_TIME_OFFS: {
      return {
        ...state,
        agentSettings: {
          ...state.agentSettings,
          timeOff: action.payload,
        },
      };
    }
    // @ts-expect-error - TS2678 - Type '"scheduling/settings/setAgentLanguage"' is not comparable to type '"scheduling/settings/setAgentSettings" | "scheduling/settings/setUserPrincipalName" | "scheduling/settings/setDailyDigest" | "scheduling/settings/setMaxEventsPerDay" | "scheduling/settings/setTimezone" | "scheduling/settings/setBookingHours" | "scheduling/settings/setUpdatedTimeOffs"'.
    case SET_AGENT_LANGUAGE: {
      return {
        ...state,
        // @ts-expect-error - TS18047 - 'state' is possibly 'null'. | TS2339 - Property 'payload' does not exist on type 'never'.
        agentSettings: {...state.agentSettings, agentLanguage: action.payload},
      };
    }
    default:
      return state;
  }
}
